import { useEffect } from "react";

import { useAtom } from "jotai";
import { selectedClientAtom } from "store";

import { useGetEmployeeData } from "state/useGetEmployeeData";
import { useGetUserClients } from "state/useGetUserClients";

export function useInitSelectClient() {
  const { data: userClients } = useGetUserClients();
  const [selectedClient, setSelectedClient] = useAtom(selectedClientAtom);

  useGetEmployeeData({
    //save employee data in cache
    clientInternalNumberGos: Number(selectedClient?.clientInternalNumberGos),
    countryCode: Number(selectedClient?.countryCode),
    enabled: !!selectedClient,
  });

  useEffect(() => {
    if (userClients) {
      if (userClients.length > 0) {
        setSelectedClient(userClients[0]);
      } else {
        setSelectedClient(null);
      }
    }
  }, [userClients]);
}
